import { useState, useEffect } from 'react';
import api from '../../services/api';
import Card, { CardTitle } from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import Table, { THead, TH, TBody, TR, TD } from '../../components/ui/Table';
import StatusBadge from '../../components/shared/StatusBadge';
import { formatDate, formatCurrency } from '../../utils/formatDate';
import toast from 'react-hot-toast';

export default function Payments() {
  const [warranties, setWarranties] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadPayments = async () => {
    try {
      const { data } = await api.get('/admin/payments');
      setWarranties(data.warranties);
    } catch (err) {
      console.error('Load payments error:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadPayments(); }, []);

  const handleConfirm = async (id) => {
    try {
      await api.patch(`/warranty/${id}/confirm`);
      toast.success('Payment confirmed');
      loadPayments();
    } catch (err) {
      toast.error('Failed to confirm');
    }
  };

  if (loading) {
    return <div className="flex items-center justify-center h-64"><div className="w-8 h-8 border-4 border-cyan-500 border-t-transparent rounded-full animate-spin" /></div>;
  }

  return (
    <div>
      <h1 className="text-2xl font-bold text-slate-100 mb-2">Warranty Requests</h1>
      <p className="text-slate-400 mb-8">Manage warranty extension requests and payments</p>

      {warranties.length > 0 ? (
        <Table>
          <THead>
            <tr><TH>Organization</TH><TH>Appliance</TH><TH>Plan</TH><TH>Amount</TH><TH>Method</TH><TH>Reference</TH><TH>Date</TH><TH>Action</TH></tr>
          </THead>
          <TBody>
            {warranties.map(w => (
              <TR key={w.id}>
                <TD>{w.organization?.shortName || w.organization?.name}</TD>
                <TD>{w.appliance?.unitName}</TD>
                <TD>{w.plan.replace('yr', '')} Year</TD>
                <TD><span className="font-medium text-slate-200">{formatCurrency(w.amount, w.currency)}</span></TD>
                <TD><span className="capitalize text-sm">{w.paymentMethod?.replace('_', ' ')}</span></TD>
                <TD>{w.paymentReference || '—'}</TD>
                <TD>{formatDate(w.createdAt)}</TD>
                <TD>
                  <Button size="sm" onClick={() => handleConfirm(w.id)}>Confirm</Button>
                </TD>
              </TR>
            ))}
          </TBody>
        </Table>
      ) : (
        <Card className="text-center py-12">
          <div className="w-12 h-12 bg-emerald-500/10 rounded-full flex items-center justify-center mx-auto mb-3">
            <svg className="w-6 h-6 text-emerald-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <p className="text-slate-400">No pending payments. All caught up!</p>
        </Card>
      )}
    </div>
  );
}
